/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import secureLocalStorage from "react-secure-storage";
import { MyContext } from '../../Context/MyProvider';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { showToast } from '../../showTost';
import Payment from '../../PaymentGateway/Payment';
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { useTranslation } from 'react-i18next';
import CryptoJS from "crypto-js";
import MapPin from "../../icon/ic_destination_long.png";
import { uid } from 'uid';
const Cart = () => {

    const { t } = useTranslation();
    const { ImgBasUrl, ApiBasUrl, paymentRes, setPaymentRes, setTotalCart, MapKey, cartstatus, SECRET_KEY } = useContext(MyContext);

    const [cartitemlist, setCartItemList] = useState([]);
    const [packagelist, setPackageList] = useState([]);
    const [totalprice, setTotalPrice] = useState(0);
    const [totalpay, setTotalPay] = useState(0);
    const [totalpay2, setTotalPay2] = useState(0);
    const [loading, setLoading] = useState(true);
    const [couponlist, setCouponList] = useState([]);
    const [showcouponlist, setShowCouponLits] = useState(false);
    const [selectcoupon, setSelectCoupon] = useState();
    const [loadingCouponCode, setLoadingCouponCode] = useState(null);
    const [timeslotlist, setTimeSlotList] = useState([]);
    const [selecttimeslot, setSelectTimeSlot] = useState("");
    const [selecttime, setSelectTime] = useState("");
    const [selectdate, setSelectdate] = useState("");
    const [addresslist, setAddressList] = useState([]);
    const [selectaddress, setSelectAddress] = useState("");
    const [isshow, setIsShow] = useState(false);
    const [mywallet, setMyWallet] = useState("");
    const [myusedwallet, setMyUsedWallet] = useState("");
    const [isDriverSelected, setIsDriverSelected] = useState(false);
    const [othertext, setOtherText] = useState("");
    const [selectmode, setSelectMode] = useState("Pickup");
    const [showaddressbox, setShowAddressBox] = useState(false);
    const [isaddres, setIsAddres] = useState(false);
    const [position, setPosition] = useState("");
    const [addresdata, setAddresData] = useState("");
    const [apiloading, setApiLoading] = useState(false);
    const [bookinglod, setBookingLod] = useState(false);
    const [bookingdata, setBookingData] = useState("");

    const navigate = useNavigate();
    const Location = useLocation();
    const { title, path } = Location.state || [];

    const Currency = secureLocalStorage.getItem("currency");
    const ServiceFees = secureLocalStorage.getItem("servicefees");

    const toggleDriverSelection = () => setIsDriverSelected(prev => !prev);

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: MapKey
    });

    useEffect(() => {
        handleFetchCartData();
    }, [cartstatus]);

    useEffect(() => {
        setMyWallet(secureLocalStorage.getItem("mywallet") || "0");

        navigator.geolocation.getCurrentPosition(position => {
            const lat = position.coords.latitude;
            const long = position.coords.longitude;
            setPosition({ lat, long });
        });

        handleFetchCartData();
        HandleGetCouponList();
        HandleGetTimeSlot();
        HandleGetAddress();

        const PaymentResponse = sessionStorage.getItem("Paymentstatus");
        if (!PaymentResponse) return;
        if (PaymentResponse === "PaymentDone") {
            setPaymentRes("PaymentDone");
        } else {
            setPaymentRes("PaymentFaild");
        }

    }, []);

    const handleFetchCartData = () => {
        const LocalCart = localStorage.getItem("Cartitem");
        if (LocalCart) {
            const bytes = CryptoJS.AES.decrypt(LocalCart, SECRET_KEY);
            var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }

        const { cartitem, packagecartitem } = decryptedData || [];

        setCartItemList(cartitem || []);
        setPackageList(packagecartitem || []);
        HandleGetTotal(cartitem, packagecartitem);
    };

    const HandleGetTotal = (cartitem, packagecartitem) => {

        const totalPackageItem = packagecartitem?.reduce((sum, item) => sum + Number(item.discount_price), 0);

        const totalCartItem = cartitem?.reduce((sum, item) => sum + Number(item.price), 0);

        const combineTotal = Number(totalPackageItem) + Number(totalCartItem);

        setTotalPrice(combineTotal);
        setTotalPay(combineTotal + Number(ServiceFees));
        setTotalPay2(combineTotal + Number(ServiceFees));
    };

    useEffect(() => {

        let adjustedTotal = totalpay2;

        if (selectcoupon?.camt) {
            adjustedTotal -= selectcoupon?.camt;
        }

        const isWalletSufficient = mywallet > totalpay;

        if (isWalletSufficient) {
            if (isDriverSelected) {
                setTotalPay(0);
                setMyUsedWallet(adjustedTotal);
                setMyWallet(mywallet - adjustedTotal);
            } else {
                setMyUsedWallet(0);
                setMyWallet(secureLocalStorage.getItem("mywallet"));
                setTotalPay(adjustedTotal);
            }
        } else {
            if (isDriverSelected) {
                setTotalPay(adjustedTotal - mywallet);
                setMyUsedWallet(mywallet);
                setMyWallet(0);
            } else {
                setMyUsedWallet(0);
                setMyWallet(secureLocalStorage.getItem("mywallet"));
                setTotalPay(adjustedTotal);
            }
        }
    }, [selectcoupon, totalpay2, isDriverSelected]);

    const HandleGetTimeSlot = () => {
        const StoreData = secureLocalStorage.getItem("Store");
        if (StoreData) {
            const { store_id } = JSON.parse(StoreData);

            axios.post(`${ApiBasUrl}/timeslot_list.php`, { store_id })
                .then((res) => {
                    setTimeSlotList(res.data.data);
                    setSelectdate(res.data.data[0].date);
                    setSelectTimeSlot(res.data.data[0]);
                    setSelectTime(res.data.data[0].slots[0]);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("timeslot_list.php", error);
                });
        }
    };

    const HandleRemoverItem = (id, index, data) => {
        const Copy = id === 1 ? [...cartitemlist] : [...packagelist];
        const useState = id === 1 ? setCartItemList : setPackageList;
        Copy.splice(index, 1);
        useState(Copy);

        if (id !== 1) {
            const FilterCartItem = cartitemlist.filter(item => item.addon_id !== data.addon_id);
            setCartItemList(FilterCartItem);
        } else {
            const FilterPackageItem = packagelist.filter(item => item.addon_id !== data.addon_id);
            setPackageList(FilterPackageItem);
        }
    };

    useEffect(() => {
        const combinedCartLength = [...cartitemlist, ...packagelist];

        setTotalCart(combinedCartLength.length);
        HandleGetTotal(cartitemlist, packagelist);

        const combinedCartItems = {
            packagecartitem: [...packagelist],
            cartitem: [...cartitemlist]
        };

        if (combinedCartLength.length > 0) {
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(combinedCartItems), SECRET_KEY).toString();
            localStorage.setItem('Cartitem', encrypted);
        } else {
            if (loading) return;
            localStorage.removeItem("Cartitem");
            navigate(path);
        }

    }, [packagelist, cartitemlist]);

    const HandleGetCouponList = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        const StoreData = secureLocalStorage.getItem("Store");

        if (Userid && StoreData) {
            const { store_id } = JSON.parse(StoreData);

            axios.post(`${ApiBasUrl}/u_couponlist.php`, { uid: Userid, store_id })
                .then((res) => {
                    setCouponList(res.data.couponlist);
                })
                .catch((error) => {
                    console.error("u_couponlist.php", error);
                });
        }
    };

    const HandleCopunApply = (item) => {
        const Userid = secureLocalStorage.getItem("Userid");
        const StoreData = secureLocalStorage.getItem("Store");

        if (Userid && StoreData) {

            setLoadingCouponCode(item.coupon_code);

            const { store_id } = JSON.parse(StoreData);
            axios.post(`${ApiBasUrl}/u_check_coupon.php`, { uid: Userid, store_id, cid: item.id })
                .then((res) => {
                    showToast({ title: res.data.ResponseMsg, id: "success" });
                    setSelectCoupon({ ccode: item.coupon_code, camt: item.coupon_val });
                    setLoadingCouponCode(null);
                    setShowCouponLits(false);
                })
                .catch((error) => {
                    console.error("u_check_coupon.php", error);
                });
        }
    };

    const getDayName = (dateString) => {
        const date = new Date(dateString);
        const options = { weekday: 'long' };
        const Day = date.toLocaleDateString('en-US', options);
        return Day.slice(0, 3).toUpperCase();
    };

    const HandleGetAddress = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${ApiBasUrl}/address_list.php`, { uid: Userid })
                .then((res) => {
                    setAddressList(res.data.AddressList);
                    if (res.data.AddressList) {
                        setSelectAddress(res.data.AddressList[0]);
                    }
                })
                .catch((error) => {
                    console.error("address_list.php", error);
                });
        }
    };

    const HandleCouponApply = () => {

        if (isDriverSelected) {
            setIsDriverSelected(false);
        }

        if (!selectcoupon?.ccode) {
            setShowCouponLits(true);
            return;
        }

        setSelectCoupon({ ccode: "", camt: "" });
    };

    useEffect(() => {
        if (!paymentRes) return;
        if (paymentRes === "PaymentDone") {
            setBookingLod(true);
            HandleBooking(0);
            setIsShow(false);
            setPaymentRes("");

        } else {
            showToast({ title: t("Payment Faild !!"), id: "error" });
            sessionStorage.removeItem("bookingdata");
            setPaymentRes("");
        }
    }, [paymentRes]);

    const HandleContonue = async () => {

        if (!selectdate) {
            showToast({ title: t("Please Select Date !!"), id: "error" });
            return;
        }

        if (!selecttime) {
            showToast({ title: t("Please Select Time !!"), id: "error" });
            return;
        }

        if (!selectaddress) {
            showToast({ title: t("Please Select Address !!"), id: "error" });
            return;
        }

        const Userid = secureLocalStorage.getItem("Userid");
        const StoreData = secureLocalStorage.getItem("Store");

        if (Userid && StoreData) {

            const { store_id } = JSON.parse(StoreData);

            const Data = {
                uid: Userid,
                address_id: selectaddress?.id,
                mode_service: selectmode,
                timeslot: selecttime,
                addition_note: othertext || "",
                safty_fees: ServiceFees,
                book_date: selectdate,
                subtotal: totalprice,
                total_amt: totalpay,
                store_id: store_id,
                service_status: "Pending",
                cou_amt: selectcoupon?.camt ? selectcoupon?.camt : 0,
                services: await HandleGetServices(),
                wall_amt: isDriverSelected ? myusedwallet : 0,
            };

            setBookingData(Data);

            if (totalpay === 0) {
                HandleBooking(Data);
                return;
            }

            setIsShow(true);
        }
    };

    const handleMapClick = (event) => {
        const lat = event.latLng.lat();
        const long = event.latLng.lng();
        setPosition({ lat, long });
    };

    const HandleGetGoogleAddress = async (lat, lng) => {
        try {
            const response = await axios.get(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${MapKey}`
            );
            const address = response.data.results[0].formatted_address;
            return address;
        } catch (error) {
            console.error('Error fetching address:', error);
        }
    };

    const HandleAddAddress = async () => {
        const Userid = secureLocalStorage.getItem("Userid");

        const { name, mobile, houseno, pincode, landmark, type, aid } = addresdata;

        if (!name || !mobile || !houseno || !pincode || !landmark || !type) {
            showToast({ title: t("Please Enter Details !!"), id: "error" });
            return;
        }

        const Data = {
            uid: Userid,
            aid: aid || '0',
            name,
            mobile,
            address: await HandleGetGoogleAddress(position.lat, position.long),
            pincode, houseno,
            landmark, type,
            lat_map: position?.lat,
            long_map: position?.long
        };

        setApiLoading(true);

        axios.post(`${ApiBasUrl}/address_user.php`, Data)
            .then((res) => {
                showToast({ title: res.data.ResponseMsg, id: "success" });
                HandleGetAddress();
                setShowAddressBox(false);
                setApiLoading(false);
                setAddresData("");
            })
            .catch((error) => {
                console.error("address_user.php", error);
            });
    };

    const HandleEditAddress = (e, item) => {
        e.stopPropagation();
        setShowAddressBox(true);

        setAddresData({
            name: item.name,
            mobile: item.mobile,
            pincode: item.pincode,
            houseno: item.hno,
            landmark: item.landmark,
            type: item.type,
            aid: item.id
        });

        setPosition({ lat: Number(item.lat_map), long: Number(item.long_map) });
    };

    const HandleGetServices = () => {

        const FilterPackageItem = packagelist.map(item => {
            return {
                service_id: item.service_id,
                item_type: item.item_type,
                service_img: item.service_img,
                service_title: item.service_title,
                service_price: item.price,
                service_discount_price: item.discount_price || 0,
                service_quantity: item.totalcart
            };
        });

        const FilterCartItem = cartitemlist.map(item => {
            return {
                service_img: item.img,
                service_title: item.title,
                service_price: item.price,
                service_discount_price: 0,
                service_quantity: 1
            };
        });

        const combaineItem = [...FilterCartItem, ...FilterPackageItem];

        return combaineItem;
    };

    const HandleBooking = async (BookingData) => {

        const LocalBookingData = secureLocalStorage.getItem("bookingdata");
        const Paymentid = secureLocalStorage.getItem("Paymentid");
        const transactionId = sessionStorage.getItem("transactionid");

        const JsonData = JSON.parse(LocalBookingData);
        var Data;

        if (BookingData) {
            Data = {
                ...BookingData,
                payment_id: totalpay === 0 ? "5" : Paymentid,
                transaction_id: totalpay === 0 ? "0" : transactionId || uid(15)
            };
        } else {
            Data = {
                ...JsonData,
                payment_id: totalpay === 0 ? "5" : Paymentid,
                transaction_id: totalpay === 0 ? "0" : transactionId || uid(15)
            };
        }

        console.log(JsonData);

        axios.post(`${ApiBasUrl}/book_service.php`, Data)
            .then((res) => {
                setBookingLod(false);
                console.log("==========================", res);
                if (res.data.ResponseCode === "200") {
                    showToast({ title: res.data.ResponseMsg, id: "success" });
                    setTotalCart(0);
                    localStorage.removeItem("Cartitem");
                    sessionStorage.removeItem("transactionid");
                    sessionStorage.removeItem("Paymentstatus");
                    sessionStorage.removeItem("bookingdata");
                    navigate("/order-history");
                } else {
                    showToast({ title: res.data.ResponseMsg, id: "error" });
                }
            })
            .catch((error) => {
                console.error("book_service.php", error);
            });
    };

    const HandleIncrement = (id) => {
        const FilterCartData = packagelist.map(item => {
            if (item.service_id === id) {
                const count = item.totalcart + 1;
                const TotalDicPrice = (Number(item.itemdisprice) * count);
                const TotalPrice = (Number(item.itemprice) * count);
                return { ...item, totalcart: count, discount_price: TotalDicPrice, price: TotalPrice };
            } else {
                return item;
            }
        });
        setPackageList(FilterCartData);
    };

    const HandleDecrement = (id) => {
        const updatedCart = packagelist.map(item => {
            if (item.service_id === id) {
                const count = item.totalcart - 1;
                if (count === 0) {
                    return null;
                } else {
                    const TotalDicPrice = (Number(item.itemdisprice) * count);
                    const TotalPrice = (Number(item.itemprice) * count);
                    return { ...item, totalcart: count, discount_price: TotalDicPrice, price: TotalPrice };
                }
            }
            return item;
        }).filter(item => item !== null);
        setPackageList(updatedCart);
    };

    return (
        <div className='cart_page my-[20px]'>
            {loading
                ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
                    <div className="loader2"></div>
                </div>
                : <div className="width_container">
                    <div className="flex items-center justify-between max-_430_:hidden">
                        <div className="border-[2px] rounded-[50px] px-[15px] py-[3px] cursor-pointer hover:bg-gray-800 group">
                            <Link to="/" className="flex items-center gap-[8px] group-hover:text-white">
                                <svg width="10" height="12" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.35401 8.64601C5.54901 8.84101 5.54901 9.15804 5.35401 9.35304C5.25601 9.45104 5.12801 9.49903 5.00001 9.49903C4.87201 9.49903 4.74401 9.45004 4.64601 9.35304L0.646006 5.35304C0.451006 5.15804 0.451006 4.84101 0.646006 4.64601L4.64601 0.646006C4.84101 0.451006 5.15804 0.451006 5.35304 0.646006C5.54804 0.841006 5.54804 1.15804 5.35304 1.35304L1.70704 4.99903L5.35401 8.64601Z" fill="currentColor" />
                                </svg>
                                <h1 className='font-bold'>{t("Home")}</h1>
                            </Link>
                        </div>
                        <div className="flex items-center gap-[10px] font-[500]">
                            <Link to={path || "/"} className='text-gray-600'>{t(title || "Home")}</Link>
                            <svg width="10" height="12" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.35401 5.35401L1.35401 9.35401C1.25601 9.45201 1.12801 9.50001 1.00001 9.50001C0.87201 9.50001 0.744006 9.45101 0.646006 9.35401C0.451006 9.15901 0.451006 8.84198 0.646006 8.64698L4.292 5.00099L0.646006 1.35499C0.451006 1.15999 0.451006 0.842959 0.646006 0.647959C0.841006 0.452959 1.15804 0.452959 1.35304 0.647959L5.35304 4.64796C5.54904 4.84196 5.54901 5.15801 5.35401 5.35401Z" fill="#25314C" />
                            </svg>
                            <h1 className='text-gray-400'>{t("My Cart")}</h1>
                        </div>
                    </div>

                    <div className="flex flex-wrap items-start justify-center gap-[20px] mt-[20px]">

                        <div className="section_details">

                            <div className="border-[1px] border-gray-300 focus-within:border-[#682afb] rounded-[10px] py-[8px] px-[10px]">
                                <div className="flex items-center gap-[10px]">
                                    <input onChange={(e) => setOtherText(e.target.value)} type="text" className='w-full outline-none' placeholder={t("Any other requirements...")} />
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.75 15V18C19.75 20.418 18.418 21.75 16 21.75H6C3.582 21.75 2.25 20.418 2.25 18V8C2.25 5.582 3.582 4.25 6 4.25H9C9.414 4.25 9.75 4.586 9.75 5C9.75 5.414 9.414 5.75 9 5.75H6C4.423 5.75 3.75 6.423 3.75 8V18C3.75 19.577 4.423 20.25 6 20.25H16C17.577 20.25 18.25 19.577 18.25 18V15C18.25 14.586 18.586 14.25 19 14.25C19.414 14.25 19.75 14.586 19.75 15ZM21.75 6.056C21.749 6.643 21.52 7.194 21.104 7.608L12.141 16.531C12 16.671 11.81 16.75 11.612 16.75H8C7.586 16.75 7.25 16.414 7.25 16V12.389C7.25 12.191 7.32799 12 7.46899 11.86L16.392 2.896C16.805 2.48 17.357 2.251 17.944 2.25C17.945 2.25 17.946 2.25 17.947 2.25C18.533 2.25 19.084 2.47801 19.499 2.89301L21.108 4.50201C21.522 4.91701 21.751 5.469 21.75 6.056ZM17.617 8.96301L15.037 6.383L8.75 12.699V15.251H11.302L17.617 8.96301ZM20.25 6.05399C20.25 5.86799 20.178 5.69301 20.047 5.56201L18.438 3.953C18.307 3.822 18.132 3.75 17.947 3.75H17.946C17.76 3.75 17.586 3.82301 17.455 3.95401L16.096 5.319L18.681 7.90399L20.046 6.54501C20.177 6.41501 20.249 6.23999 20.25 6.05399Z" fill="#25314C" />
                                    </svg>
                                </div>
                            </div>

                            <div className="mt-[20px]">
                                <h1 className='font-bold text-[20px]'>{t("Mode of service :")}</h1>
                                <div className="flex items-center gap-[20px] mt-[10px] scroll-container">
                                    {["Pickup", "Walk In"].map((item, index) => {
                                        const isSelect = selectmode === item;
                                        return <div key={index} onClick={() => setSelectMode(item)} className="flex items-center cursor-pointer">
                                            <div className="w-[25px]">
                                                <div className={`w-[16px] h-[16px] border-[2px] rounded-full p-[2px] duration-[0.5s] ${isSelect && "border-[#682afb]"}`}>
                                                    <div className={`w-full h-full rounded-full duration-[0.5s] ${isSelect && "bg-[#682afb]"}`}></div>
                                                </div>
                                            </div>
                                            <h1 className='text-[17px]'>{t(item)}</h1>
                                        </div>
                                    })}
                                </div>
                            </div>

                            <div className="mt-[20px]">
                                <h1 className='font-bold text-[20px]'>{t("Select Date Of Service :")}</h1>
                                <div className="flex items-center gap-[10px] mt-[10px] scroll-container">
                                    {timeslotlist.map((item, index) => {
                                        const GetDay = item.date.split("-")[2];
                                        return <div key={index} onClick={() => { setSelectTimeSlot(item); setSelectdate(item.date); setSelectTime(item.slots[0]) }} className={`date_slot ${selectdate === item.date && "select_date_slot"}`}>
                                            <h1 className='text-[18px] font-bold'>{GetDay}</h1>
                                            <span className='text-[16px]'>{getDayName(item.date)}</span>
                                        </div>
                                    })}
                                </div>
                            </div>

                            <div className="mt-[20px]">
                                <h1 className='font-bold text-[20px]'>{t("Select Time Of Service :")}</h1>
                                <div className="flex flex-wrap items-center gap-[10px] mt-[10px]">
                                    {selecttimeslot.slots.map((item, index) => {
                                        const isSelected = selecttime === item;
                                        return <div key={index} onClick={() => setSelectTime(item)} className={`time_slot ${isSelected && "select_time_slot"}`}>
                                            <h1 className='text-[16px] font-[500]'>{item}</h1>
                                        </div>
                                    })}
                                </div>
                            </div>

                            <div className="mt-[20px]">
                                <div className="flex items-center gap-[10px] justify-between">
                                    <h1 className='font-bold text-[20px]'>{t("Select Address :")}</h1>
                                    <button onClick={() => setIsAddres(true)} className='text-[15px] font-[500] text-[#682afb]'>{t("+ Select Address")}</button>
                                </div>
                                <div className="mt-[10px]">
                                    {selectaddress && <div className="w-full border-[1px] border-[#682afb] py-[10px] px-[15px] rounded-[10px] cursor-pointer">
                                        <div className="flex items-center gap-[10px]">
                                            <div className="border-[1px] border-[#682afb] bg-[#692afb33] p-[8px] rounded-[5px]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 2.5C7.313 2.5 3.5 6.313 3.5 11C3.5 15.983 8.129 19.041 11.192 21.064L11.722 21.416C11.806 21.472 11.903 21.5 11.999 21.5C12.095 21.5 12.192 21.472 12.276 21.416L12.806 21.064C15.869 19.041 20.498 15.983 20.498 11C20.5 6.313 16.687 2.5 12 2.5ZM12 13.5C10.619 13.5 9.5 12.381 9.5 11C9.5 9.619 10.619 8.5 12 8.5C13.381 8.5 14.5 9.619 14.5 11C14.5 12.381 13.381 13.5 12 13.5Z" fill="#682afb" />
                                                </svg>

                                            </div>
                                            <div className="">
                                                <h1 className='font-bold text-[17px] text-[#682afb]'>{selectaddress?.type}</h1>
                                                <p className='text-[15px] text-gray-700'>{selectaddress?.hno}, {selectaddress?.address}</p>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>

                            <div className="mt-[20px] flex items-center justify-end">
                                <button onClick={HandleContonue} className='continue_button'>
                                    <div className="flex items-center gap-[10px]">
                                        <span>{t("Continue")}</span>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21.6919 12.2871C21.6539 12.3791 21.599 12.462 21.53 12.531L14.53 19.531C14.384 19.677 14.192 19.751 14 19.751C13.808 19.751 13.616 19.678 13.47 19.531C13.177 19.238 13.177 18.763 13.47 18.47L19.1899 12.75H3C2.586 12.75 2.25 12.414 2.25 12C2.25 11.586 2.586 11.25 3 11.25H19.189L13.469 5.53005C13.176 5.23705 13.176 4.76202 13.469 4.46902C13.762 4.17602 14.237 4.17602 14.53 4.46902L21.53 11.469C21.599 11.538 21.6539 11.6209 21.6919 11.7129C21.7679 11.8969 21.7679 12.1031 21.6919 12.2871Z" fill="white" />
                                        </svg>
                                    </div>
                                </button>
                            </div>
                        </div>

                        <div className="section_cart">
                            <div className="">
                                {cartitemlist?.map((item, index) => {
                                    return <div key={index} className="border-[1px] border-gray-300 rounded-[10px] p-[10px] mt-[10px]">
                                        <div className="flex items-start justify-between">
                                            <div className="flex items-center gap-[10px]">
                                                <img src={ImgBasUrl + item.img} className='w-[80px] h-[80px] object-cover border-[1px] border-gray-400 rounded-[10px]' alt="" />
                                                <div className="">
                                                    <h1 className='text-[17px] font-[500]'>{item.title}</h1>
                                                    <div className="flex items-center gap-[10px]">
                                                        <p className='font-[500]'>{item.price === 0 ? "Free" : Currency + item.price}</p>
                                                        {item.dprice && <p className='text-gray-500 line-through'>{Currency}{item.dprice}</p>}
                                                    </div>
                                                </div>
                                            </div>
                                            <button onClick={() => HandleRemoverItem(1, index, item)}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M21 5.5H17.441C16.36 5.5 16.274 5.24201 16.018 4.47501L15.815 3.868C15.543 3.05 14.78 2.5 13.918 2.5H10.08C9.218 2.5 8.455 3.05 8.183 3.868L7.981 4.47501C7.725 5.24201 7.639 5.5 6.558 5.5H3C2.724 5.5 2.5 5.724 2.5 6C2.5 6.276 2.724 6.5 3 6.5H4.532L5.314 18.232C5.453 20.309 6.725 21.5 8.806 21.5H15.193C17.274 21.5 18.547 20.309 18.685 18.232L19.467 6.5H21C21.276 6.5 21.5 6.276 21.5 6C21.5 5.724 21.276 5.5 21 5.5ZM9.132 4.18401C9.269 3.77501 9.64999 3.5 10.081 3.5H13.919C14.35 3.5 14.731 3.77401 14.867 4.18401L15.07 4.791C15.151 5.033 15.237 5.275 15.355 5.5H8.646C8.764 5.274 8.85 5.033 8.931 4.791L9.132 4.18401ZM17.688 18.166C17.585 19.715 16.746 20.5 15.194 20.5H8.80701C7.25501 20.5 6.416 19.715 6.313 18.166L5.535 6.5H6.559C6.683 6.5 6.784 6.486 6.894 6.479C6.929 6.487 6.963 6.5 7 6.5H17C17.038 6.5 17.071 6.486 17.106 6.479C17.216 6.487 17.317 6.5 17.441 6.5H18.465L17.688 18.166ZM14.5 11V16C14.5 16.276 14.276 16.5 14 16.5C13.724 16.5 13.5 16.276 13.5 16V11C13.5 10.724 13.724 10.5 14 10.5C14.276 10.5 14.5 10.724 14.5 11ZM10.5 11V16C10.5 16.276 10.276 16.5 10 16.5C9.724 16.5 9.5 16.276 9.5 16V11C9.5 10.724 9.724 10.5 10 10.5C10.276 10.5 10.5 10.724 10.5 11Z" fill="#25314C" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                })}

                                {packagelist?.map((item, index) => {
                                    return <div key={index} className="border-[1px] border-gray-300 rounded-[10px] p-[10px] mt-[10px]">
                                        <div className={`flex ${item.item_type === "accessory" ? "items-center" : "items-start"} justify-between`}>
                                            <div className="flex items-center gap-[10px] overflow-hidden w-[80%] max-_430_:w-[100%]">
                                                <img src={ImgBasUrl + item.service_img} className='w-[80px] h-[80px] object-cover border-[1px] border-gray-300 rounded-[10px]' alt="" />
                                                <div className="overflow-hidden">
                                                    <h1 className='text-[17px] font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.service_title}</h1>
                                                    <div className="flex items-center gap-[10px]">
                                                        {item.discount_price && <p className='font-[500]'>{Currency}{item.discount_price}</p>}
                                                        <p className='text-gray-500 line-through'>{Currency}{item.price}</p>
                                                    </div>
                                                    <div className="max-_430_:block hidden">
                                                        {item.item_type === "accessory"
                                                            && <div className="flex items-center border-[1px] border-[#682afb] rounded-[5px] overflow-hidden">
                                                                <button onClick={() => HandleDecrement(item.service_id)} className='bg-[#682afb] text-white px-[7px] text-[18px] max-_430_:w-full'>-</button>
                                                                <span className='bg-[#692afb44] text-[#682afb] text-center px-[8px] text-[18px] max-_430_:w-full font-[500]'>{item.totalcart}</span>
                                                                <button onClick={() => HandleIncrement(item.service_id)} className='bg-[#682afb] text-white px-[5px] text-[18px] max-_430_:w-full'>+</button>
                                                            </div>}
                                                    </div>
                                                </div>
                                            </div>
                                            {item.item_type === "accessory"
                                                ? <div className="flex items-center max-_430_:hidden border-[1px] border-[#682afb] rounded-[5px] overflow-hidden">
                                                    <button onClick={() => HandleDecrement(item.service_id)} className='bg-[#682afb] text-white px-[7px] text-[18px] max-_430_:w-full'>-</button>
                                                    <span className='bg-[#692afb44] text-[#682afb] px-[8px] text-[18px] max-_430_:w-full font-[500]'>{item.totalcart}</span>
                                                    <button onClick={() => HandleIncrement(item.service_id)} className='bg-[#682afb] text-white px-[5px] text-[18px] max-_430_:w-full'>+</button>
                                                </div>
                                                : <button onClick={() => HandleRemoverItem(2, index, item)}>
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M21 5.5H17.441C16.36 5.5 16.274 5.24201 16.018 4.47501L15.815 3.868C15.543 3.05 14.78 2.5 13.918 2.5H10.08C9.218 2.5 8.455 3.05 8.183 3.868L7.981 4.47501C7.725 5.24201 7.639 5.5 6.558 5.5H3C2.724 5.5 2.5 5.724 2.5 6C2.5 6.276 2.724 6.5 3 6.5H4.532L5.314 18.232C5.453 20.309 6.725 21.5 8.806 21.5H15.193C17.274 21.5 18.547 20.309 18.685 18.232L19.467 6.5H21C21.276 6.5 21.5 6.276 21.5 6C21.5 5.724 21.276 5.5 21 5.5ZM9.132 4.18401C9.269 3.77501 9.64999 3.5 10.081 3.5H13.919C14.35 3.5 14.731 3.77401 14.867 4.18401L15.07 4.791C15.151 5.033 15.237 5.275 15.355 5.5H8.646C8.764 5.274 8.85 5.033 8.931 4.791L9.132 4.18401ZM17.688 18.166C17.585 19.715 16.746 20.5 15.194 20.5H8.80701C7.25501 20.5 6.416 19.715 6.313 18.166L5.535 6.5H6.559C6.683 6.5 6.784 6.486 6.894 6.479C6.929 6.487 6.963 6.5 7 6.5H17C17.038 6.5 17.071 6.486 17.106 6.479C17.216 6.487 17.317 6.5 17.441 6.5H18.465L17.688 18.166ZM14.5 11V16C14.5 16.276 14.276 16.5 14 16.5C13.724 16.5 13.5 16.276 13.5 16V11C13.5 10.724 13.724 10.5 14 10.5C14.276 10.5 14.5 10.724 14.5 11ZM10.5 11V16C10.5 16.276 10.276 16.5 10 16.5C9.724 16.5 9.5 16.276 9.5 16V11C9.5 10.724 9.724 10.5 10 10.5C10.276 10.5 10.5 10.724 10.5 11Z" fill="#25314C" />
                                                    </svg>
                                                </button>}
                                        </div>
                                    </div>
                                })}
                            </div>

                            {secureLocalStorage.getItem("mywallet") !== 0 && <div className="border-[1px] border-gray-300 rounded-[10px] py-[10px] px-[20px] mt-[20px]">
                                <div className="flex items-center justify-between mb-[10px]">
                                    <h1 className='font-[500] text-[17px]'>{t("Pay from Wallet")}</h1>
                                    <label className="switch">
                                        <input type="checkbox" checked={isDriverSelected} onChange={toggleDriverSelection} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="border-[1px] border-[#8080803b] p-[10px] rounded-[10px] flex items-center justify-between">
                                    <div className="flex items-center gap-[5px]">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.75 6.297V6C18.75 3.582 17.418 2.25 15 2.25H5C3.483 2.25 2.25 3.483 2.25 5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V10C21.75 7.845 20.692 6.553 18.75 6.297ZM20.25 15.75H16.5C15.535 15.75 14.75 14.965 14.75 14C14.75 13.035 15.535 12.25 16.5 12.25H20.25V15.75ZM5 3.75H15C16.577 3.75 17.25 4.423 17.25 6V6.25H5C4.311 6.25 3.75 5.689 3.75 5C3.75 4.311 4.311 3.75 5 3.75ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V7.44897C4.125 7.64097 4.55 7.75 5 7.75H18C19.577 7.75 20.25 8.423 20.25 10V10.75H16.5C14.708 10.75 13.25 12.208 13.25 14C13.25 15.792 14.708 17.25 16.5 17.25H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM17.01 13H17.02C17.573 13 18.02 13.448 18.02 14C18.02 14.552 17.573 15 17.02 15C16.468 15 16.015 14.552 16.015 14C16.015 13.448 16.458 13 17.01 13Z" fill="#25314C" />
                                        </svg>
                                        <h1 className='font-[500] text-[16px]'>{t("My Wallet")}</h1>
                                    </div>
                                    <h1 className='font-[500] text-[17px] text-[#682afb]'>{Currency}{mywallet}</h1>
                                </div>
                            </div>}

                            <div className="border-[1px] border-gray-300 rounded-[10px] py-[10px] px-[20px] mt-[20px]">
                                <div className="flex items-center justify-between pb-[8px]">
                                    <div className="flex items-center gap-[10px]">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="#682afb" stroke="none">
                                            <path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path></svg>
                                        <h1 className='font-[500] text-[18px] text-[#682afb]'>{t("Apply Coupon")}</h1>
                                    </div>
                                    <button onClick={HandleCouponApply} className={`font-[500] ${selectcoupon?.ccode ? "text-[red]" : "text-[#682afb]"} text-[18px]`}>{selectcoupon?.ccode ? t("Remove") : t("Apply")}</button>
                                </div>
                                <div className="border-t-[1px] pt-[8px]">
                                    <div onClick={HandleCouponApply} className="flex items-center justify-between cursor-pointer">
                                        <h1 className=" text-gray-400 text-[16px] font-[500]">{selectcoupon?.ccode ? selectcoupon.ccode : t("View All Coupons")}</h1>
                                        <svg stroke="currentColor" fill="none" viewBox="0 0 24 24" className="text-gray-400 text-[20px]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                            <path d="m9 18 6-6-6-6"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div className="border-t-[1px] mt-[20px]">
                                <h1 className='text-[22px] font-[500] mt-[15px]'>{t("Bill Summary")}</h1>

                                <div className="flex items-center justify-between mt-[10px]">
                                    <h1 className='text-[17px]'>{t("Item Total (Incl. of taxes)")}</h1>
                                    <span>{Currency}{totalprice}</span>
                                </div>

                                {selectcoupon?.camt && <div className="flex items-center justify-between mt-[10px]">
                                    <h1 className='text-[17px]'>{t("Coupon Amount")}</h1>
                                    <span>-{Currency}{selectcoupon?.camt}</span>
                                </div>}

                                {isDriverSelected && <div className="flex items-center justify-between mt-[10px]">
                                    <h1 className='text-[17px]'>{t("Wallet Amount")}</h1>
                                    <span>-{Currency}{myusedwallet}</span>
                                </div>}

                                <div className="flex items-center justify-between mt-[10px]">
                                    <h1 className='text-[17px]'>{t("Safety Fees")}</h1>
                                    <span>+{Currency}{ServiceFees}</span>
                                </div>

                                <div className="border-t-[2px] border-dashed mt-[10px]"></div>

                                <div className="flex items-center justify-between mt-[10px] font-bold">
                                    <h1 className='text-[17px]'>{t("Total Pay")}</h1>
                                    <span>{Currency}{totalpay}</span>
                                </div>

                            </div>
                        </div>

                    </div>

                </div >}

            {showcouponlist && <div onClick={() => setShowCouponLits(false)} className="bottem_sheet items-center">
                <div style={{ borderRadius: "10px" }} onClick={(e) => e.stopPropagation()} className="bottem_box py-[10px] px-[15px]">
                    <div className="max-h-[650px] scroll-container">
                        {couponlist.map((item, index) => {
                            const isLoading = loadingCouponCode === item.coupon_code;
                            return <div key={index} className="border-[1px] rounded-[10px] py-[8px] px-[10px] mt-[8px]">
                                <div className="flex items-center justify-between ">
                                    <div className="">
                                        <h1 className='font-bold text-[17px]'>{item.coupon_title}</h1>
                                        <p className='font-[500] text-[15px] text-gray-400'>{item.coupon_subtitle}</p>

                                        <div className="">
                                            <h1>{t("Coupon Code :")} <span className='font-[500] text-[#682afb]'>{item.coupon_code}</span></h1>
                                            <h1>{t("Coupon Amount :")} <span className='font-[500]'>{Currency}{item.coupon_val}</span></h1>
                                            <h1>{t("Minimum Amount :")} <span className='font-[500]'>{Currency}{item.min_amt}</span></h1>
                                            <h1>{t("Ex Date :")} <span className='font-[500]'>{item.expire_date}</span></h1>
                                        </div>

                                        <button onClick={() => HandleCopunApply(item)} disabled={totalpay < item.min_amt} className={`${totalpay < item.min_amt ? "coupon_button_disabled" : "coupon_button_active"} rounded-[50px] mt-[5px]`}>
                                            {isLoading
                                                ? <div className="loader mx-auto"></div>
                                                : <span>{t("Apply Coupon")}</span>}
                                        </button>
                                    </div>
                                    <img src={ImgBasUrl + item.coupon_img} className='w-[60px]' alt="" />
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>}

            {isshow && <div onClick={() => setIsShow(false)} className="bottem_sheet items-end">
                <div onClick={(e) => e.stopPropagation()} className="bottem_box py-[10px] px-[15px]">
                    <Payment Index={1} Amount={totalpay} Data={bookingdata} />
                </div>
            </div>}

            {showaddressbox && <div onClick={() => setShowAddressBox(false)} className="bottem_sheet items-end">
                <div onClick={(e) => e.stopPropagation()} className="bottem_box py-[10px] px-[15px]">
                    <div className="flex items-center gap-[20px]">
                        <button onClick={() => { setIsAddres(true); setShowAddressBox(false); setAddresData("") }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                            </svg>
                        </button>
                        <h1 className='font-bold text-[20px]'>{t("Add Address")}</h1>
                    </div>
                    <div className="google_map mt-[10px]">
                        {isLoaded && <GoogleMap
                            center={{ lat: position.lat, lng: position.long }}
                            zoom={15}
                            onClick={handleMapClick}
                        >
                            <Marker icon={{
                                url: MapPin,
                                scaledSize: new window.google.maps.Size(20, 35),
                            }} position={{ lat: position.lat, lng: position.long }} />
                        </GoogleMap>}
                    </div>

                    <div className="mt-[5px]">
                        <input value={addresdata.name} onChange={(e) => setAddresData({ ...addresdata, name: e.target.value })} className="w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#682afb]" placeholder={t("Name")} type="text" />
                    </div>
                    <div className="mt-[5px]">
                        <input value={addresdata.mobile} onChange={(e) => setAddresData({ ...addresdata, mobile: e.target.value })} className="w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#682afb]" placeholder={t("Number")} type="number" />
                    </div>
                    <div className="mt-[5px]">
                        <input value={addresdata.houseno} onChange={(e) => setAddresData({ ...addresdata, houseno: e.target.value })} className="w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#682afb]" placeholder={t("House No")} type="text" />
                    </div>
                    <div className="mt-[5px]">
                        <input value={addresdata.pincode} onChange={(e) => setAddresData({ ...addresdata, pincode: e.target.value })} className="w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#682afb]" placeholder={t("Pincode")} type="number" />
                    </div>
                    <div className="mt-[5px]">
                        <input value={addresdata.landmark} onChange={(e) => setAddresData({ ...addresdata, landmark: e.target.value })} className="w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#682afb]" placeholder={t("Landmark")} type="text" />
                    </div>
                    <div className="mt-[5px]">
                        <h1 className='font-[500] text-[15px]'>{t("Save address as")}</h1>
                        <input value={addresdata.type} onChange={(e) => setAddresData({ ...addresdata, type: e.target.value })} className="w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#682afb]" placeholder={t("Eg:Home, Office, Other...")} type="text" />
                    </div>

                    <button onClick={HandleAddAddress} className='button rounded-[10px] mt-[10px]'>
                        {apiloading
                            ? <div className='loader mx-auto'></div>
                            : <span>{t("Add Address")}</span>}
                    </button>
                </div>
            </div>}

            {isaddres && <div onClick={() => setIsAddres(false)} className="bottem_sheet items-end">
                <div onClick={(e) => e.stopPropagation()} className="bottem_box py-[10px] px-[15px]">
                    <div className="flex items-center gap-[10px] justify-between">
                        <h1 className='font-bold text-[20px]'>{t("Choose Address")}</h1>
                        {addresslist?.length >= 1 && <button onClick={() => { setShowAddressBox(true); setIsAddres(false) }} className='text-[15px] font-[500] text-[#682afb]'>{t("+ Add Address")}</button>}
                    </div>
                    <div className="max-h-[500px] scroll-container">
                        {addresslist?.length >= 1
                            ? addresslist?.map((item, index) => {
                                return <div key={index} onClick={() => { setSelectAddress(item); setIsAddres(false) }} className={`address_box ${selectaddress.id === item.id && "address_box_select"}`}>
                                    <div className="flex items-center gap-[10px] justify-between">
                                        <h1 className='font-[500] text-[17px]'>{item.type}</h1>
                                        <button onClick={(e) => { HandleEditAddress(e, item); setIsAddres(false) }} className='font-[500] text-[#682afb]'>
                                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.24264 18.9967H21V20.9967H3V16.754L12.8995 6.85453L17.1421 11.0972L9.24264 18.9967ZM14.3137 5.44032L16.435 3.319C16.8256 2.92848 17.4587 2.92848 17.8492 3.319L20.6777 6.14743C21.0682 6.53795 21.0682 7.17112 20.6777 7.56164L18.5563 9.68296L14.3137 5.44032Z"></path>
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="flex items-center gap-[5px] overflow-hidden">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 2.25C7.175 2.25 3.25 6.175 3.25 11C3.25 16.118 7.94699 19.2199 11.055 21.2729L11.584 21.624C11.71 21.708 11.855 21.75 12 21.75C12.145 21.75 12.29 21.708 12.416 21.624L12.945 21.2729C16.053 19.2199 20.75 16.118 20.75 11C20.75 6.175 16.825 2.25 12 2.25ZM12.119 20.021L12 20.1001L11.881 20.021C8.871 18.033 4.75 15.311 4.75 11C4.75 7.002 8.002 3.75 12 3.75C15.998 3.75 19.25 7.002 19.25 11C19.25 15.311 15.128 18.034 12.119 20.021ZM12 7.75C10.208 7.75 8.75 9.208 8.75 11C8.75 12.792 10.208 14.25 12 14.25C13.792 14.25 15.25 12.792 15.25 11C15.25 9.208 13.792 7.75 12 7.75ZM12 12.75C11.035 12.75 10.25 11.965 10.25 11C10.25 10.035 11.035 9.25 12 9.25C12.965 9.25 13.75 10.035 13.75 11C13.75 11.965 12.965 12.75 12 12.75Z" fill="#25314C" />
                                        </svg>
                                        <div className="leading-[19px] w-[90%]">
                                            <p className='text-[14px] text-gray-600'>{item.hno}, {item.address}</p>
                                        </div>
                                    </div>
                                </div>
                            })
                            : <div className="h-[200px] flex items-center justify-center">
                                <button onClick={() => { setShowAddressBox(true); setIsAddres(false) }} className='border-[1px] border-[#682afb] border-dashed px-[30px] py-[8px] text-[#682afb] font-[500] rounded-[10px]'>+ Add Address</button>
                            </div>
                        }
                    </div>
                </div>
            </div>}

            {bookinglod && <div className="h-[100vh] w-full bg-[#00000067] fixed top-0 left-0 z-[999] flex items-center justify-center">
                <div style={{ width: "33px", height: "33px" }} className="loader"></div>
            </div>}

        </div >
    )
}

export default Cart;
/* jshint ignore:end */